import { ITemplate } from "interfaces";
import { httpCollection } from "us.helper/http/collection";

export default {
  templates: {
    get: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            "templates",
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    save: (template: ITemplate): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "communicationservice",
            "template",
            template
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    getDocumentTypes: (): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            "channels",
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    getById: ({
      templateId,
      version,
    }: {
      templateId: number;
      version?: number;
    }): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          if (version) {
            const { data, status } = await httpCollection.get(
              "communicationservice",
              `template/${templateId}?version=${version}`,
              {}
            );
            resolve({ data, status });
          } else {
            const { data, status } = await httpCollection.getById(
              "communicationservice",
              "template",
              templateId
            );
            resolve({ data, status });
          }
        } catch (error) {
          reject(error);
        }
      });
    },
    getHistory: ({ templateId }: { templateId: number }) => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.getById(
            "communicationservice",
            "template/history",
            templateId
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
